import React from "react";
import { Check, Circle, TrendingUp } from "lucide-react";

export function ProfileStrength({ form, photos = [], mainPhotoId, selfieVerified, idVerified, onGetVerified }) {
  const items = [
    { key: "main_photo", label: "Add a main photo", done: !!(mainPhotoId || photos[0]) },
    { key: "more_photos", label: "Add more photos (2+)", done: (photos || []).length >= 2 },
    { key: "headline", label: "Write a headline", done: !!(form.headline || "").trim() },
    { key: "about", label: "Write your About Me", done: !!(form.about_me || "").trim() },
    { key: "intention", label: "Set your dating intention", done: !!form.primary_intention },
    { key: "interests", label: "Pick some interests", done: (form.interests || []).length > 0 },
    { key: "hobbies", label: "Add a few hobbies", done: (form.hobbies || []).length > 0 },
    { key: "activities", label: "Choose ideal date activities", done: (form.date_preferences || []).length > 0 },
    { key: "height", label: "Add your height", done: !!form.height_cm },
    { key: "verified", label: "Get verified", done: !!(selfieVerified || idVerified), action: onGetVerified },
  ];
  const done = items.filter((i) => i.done).length;
  const pct = Math.round((done / items.length) * 100);
  const color = pct >= 80 ? "#6FD79E" : pct >= 50 ? "#E0B84A" : "#E58CA0";

  return (
    <div data-testid="profile-strength" className="rounded-2xl border border-white/10 bg-[#141113]/60 p-5 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-serif text-lg text-[#FBF8F3] flex items-center gap-2"><TrendingUp size={17} className="text-[#D4AF37]" /> Profile Strength</h3>
        <span data-testid="profile-strength-pct" className="font-serif text-xl" style={{ color }}>{pct}%</span>
      </div>
      <div className="h-2 rounded-full bg-[#0C0A0A] overflow-hidden mb-4">
        <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, background: color }} />
      </div>
      <p className="text-[11px] text-[#9E978E] mb-3">A richer profile earns more date offers. This is just a guide — you can use DateBid at any strength.</p>
      <div className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {items.map((i) => (
          <div key={i.key} className="flex items-center gap-2 text-sm">
            {i.done ? <Check size={15} className="text-[#6FD79E] shrink-0" /> : <Circle size={14} className="text-[#9E978E] shrink-0" />}
            <span className={i.done ? "text-[#9E978E] line-through" : "text-[#D8D2C9]"}>{i.label}</span>
            {!i.done && i.action && (
              <button data-testid={`strength-action-${i.key}`} onClick={i.action} className="text-[11px] text-[#D4AF37] underline underline-offset-2 hover:text-[#F3D98B]">Complete</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
